<template>
  <span v-if="readonly && modelValue == null" class="text-muted">لا يوجد تقييم</span>
  <div v-else class="follow-up-rating" :role="readonly ? 'img' : 'radiogroup'" :aria-label="readonly ? `${modelValue} من 5 نجوم` : 'التقييم من 1 إلى 5 نجوم'">
    <label v-for="star in 5" :key="star" :class="{ selected: star <= modelValue || (readonly && star - 0.5 <= modelValue), interactive: !readonly }">
      <input v-if="!readonly" type="radio" :name="name" :value="star" :checked="modelValue === star"
             :disabled="disabled" :aria-label="`${star} من 5 نجوم`" @change="$emit('update:modelValue', star)">
      <i :class="starIcon(star)" aria-hidden="true"></i>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Number, default: null },
    readonly: Boolean,
    disabled: Boolean,
    name: { type: String, default: 'follow-up-rating' },
  },
  emits: ['update:modelValue'],
  methods: {
    starIcon(star) {
      if (star <= this.modelValue) return 'pi pi-star-fill';
      // Half-star steps round down visually; the adjacent number keeps the decimal.
      if (this.readonly && star - 0.5 <= this.modelValue) return 'pi pi-star-half-fill';
      return 'pi pi-star';
    },
  },
};
</script>

<style scoped>
.follow-up-rating { display: inline-flex; gap: .4rem; align-items: center; }
label { position: relative; padding: .25rem; color: var(--text-muted, #6c757d); }
label.selected { color: var(--gold, var(--primary-color, #c79734)); }
label.interactive { cursor: pointer; font-size: 1.5rem; }
input { position: absolute; opacity: 0; width: 100%; height: 100%; inset: 0; cursor: inherit; }
label:focus-within { outline: 2px solid currentColor; outline-offset: 2px; border-radius: .25rem; }
</style>
